/**
 * Labstep
 *
 * @module components/Thread/CountIcon
 * @desc A component showing the thread count + comments icon
 */

import { ICONS } from 'labstep-web/constants/icons';
import styles from 'labstep-web/core/Action/Icon/styles.module.scss';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import type React from 'react';
import { Icon } from 'semantic-ui-react';
import type { IThreadCountIconProps } from './types';

export const ThreadCountIcon: React.FC<IThreadCountIconProps> = ({
  count,
  popup = 'Notes',
  onClick,
}) => (
  <Popup
    trigger={
      <div
        data-cy="components/Thread/CountIcon"
        className={styles.iconContainer}
        style={{ alignItems: 'center' }}
        onClick={onClick}
      >
        <Icon.Group>
          <Icon name={ICONS.thread.primary} />
          {count > 0 && (
            <Icon name="circle" corner="top right" color="red" />
          )}
        </Icon.Group>
      </div>
    }
    size="mini"
    content={popup}
  />
);
